import { A } from '@solidjs/router';
import type { Product } from '~/data/products';
import './ProductCard.css';

interface Props {
  product: Product;
  compact?: boolean;
}

export function ProductCard(props: Props) {
  const { product } = props;
  const isInStock = product.status === 'in_stock';
  const statusClass = isInStock ? 'tag--stock' : 'tag--supplier';

  return (
    <A
      class="product-card"
      classList={{
        'product-card--compact': props.compact,
        'product-card--featured': isInStock,
      }}
      href={`/products/${product.slug}`}
      aria-label={`${product.fullName} — ${product.statusLabel}, ${product.price}`}
    >
      <div class="product-card__media">
        <img
          src={product.image}
          alt={`Двигатель ${product.fullName}`}
          loading="lazy"
          decoding="async"
          width="800"
          height="800"
        />
        <span class={`tag ${statusClass} product-card__status`}>
          {product.statusLabel}
        </span>
      </div>

      <div class="product-card__body">
        <div class="product-card__brand">{product.brand}</div>
        <h3 class="product-card__title">{product.model}</h3>
        <p class="product-card__desc">{product.shortDescription}</p>

        <div class="product-card__foot">
          <div class="product-card__price">
            <span class="product-card__price-label">Цена</span>
            <span class="product-card__price-value">{product.price}</span>
          </div>
          <div class="product-card__delivery">
            <span class="product-card__delivery-label">
              {product.status === 'in_stock' ? 'Готов к отгрузке' : 'Срок поставки'}
            </span>
            <span class="product-card__delivery-value">
              {product.leadTime}
            </span>
          </div>
        </div>

        <span class="product-card__arrow" aria-hidden="true">
          Перейти к товару <span>→</span>
        </span>
      </div>
    </A>
  );
}
